import React from 'react';
import LabelInput from '../../../elements/LabelImput';
import MolLink from '../../Basepage/parts/Menu/MolLink';
//import {img01_activ,img01_inactiv } from "./Componnents/StatusImages"
import './OrderInfo.scss';

import img01_inactiv from './Componnents/StatusImages/01-Ihr-Auftrag-grau.svg';
import img01_activ from './Componnents/StatusImages/01-Ihr-Auftrag.svg';
import img02_inactiv from './Componnents/StatusImages/02-Bestellt-grau.svg';
import img02_activ from './Componnents/StatusImages/02-Bestellt.svg';
import img03_inactiv from './Componnents/StatusImages/03-Bearbeitung-grau.svg';
import img03_activ from './Componnents/StatusImages/03-In-Bearbeitung.svg';
import img04_inactiv from './Componnents/StatusImages/04-Versand-Buchbutler-grau.svg';
import img04_activ from './Componnents/StatusImages/04-Versand-Buchbutler.svg';
import img05_inactiv from './Componnents/StatusImages/05-Tracking-grau.svg';
import img05_activ from './Componnents/StatusImages/05-Tracking.svg';
import img06_inactiv from './Componnents/StatusImages/06-Versandbereit-grau.svg';
import img06_activ from './Componnents/StatusImages/06-Versandbereit.svg';
import img07_inactiv from './Componnents/StatusImages/07-Versand-zu-Ihnen-grau.svg';
import img07_activ from './Componnents/StatusImages/07-Versand-zu-Ihnen.svg';
import img08_inactiv from './Componnents/StatusImages/08-Zustellung-grau.svg';
import img08_activ from './Componnents/StatusImages/08-Zustellung.svg';
import img09_activ from './Componnents/StatusImages/09-Retoure.svg';
import img_storno from './Componnents/StatusImages/Storno-01.svg';

interface OrderInfoProp {
  data: any;
  apiBase: string;
}

export default class OrderInfo_mol extends React.Component<OrderInfoProp> {
  render(): React.ReactNode {
    let data = this.props.data;

    let lieferAddesse = '';

    if (this.props.data.orderInfo.anrede != '')
      lieferAddesse += this.props.data.orderInfo.anrede;

    lieferAddesse +=
      this.props.data.orderInfo.vorname +
      ' ' +
      this.props.data.orderInfo.nachname +
      '\n';

    if (this.props.data.orderInfo.zusatz != '') {
      lieferAddesse += this.props.data.orderInfo.zusatz + '\n';
    }

    lieferAddesse +=
      this.props.data.orderInfo.strasse +
      ' ' +
      this.props.data.orderInfo.hausnummer +
      '\n';

    lieferAddesse +=
      this.props.data.orderInfo.plz +
      ' ' +
      this.props.data.orderInfo.ort +
      '\n';

    lieferAddesse += this.props.data.orderInfo.land;

    let downloadPrefix =
      this.props.apiBase +
      (this.props.apiBase.endsWith('/') ? '' : '/') +
      'Download.php?type=rechnung' +
      '&mol_auftrag_id=' +
      this.props.data.orderInfo.mol_auftrag_id;

    let besteldatum = new Date(
      this.props.data.orderInfo.bestelldatum,
    ).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    return (
      <div id="OrderInfo">
        <form>
          <LabelInput
            id="auftragsnummer"
            name="auftragsnummer"
            labelText="Auftragsnummer"
            type="text"
            inputDynparam={{
              defaultValue: this.props.data.orderInfo.mol_auftrag_id,
              readOnly: true,
            }}
          />
          <label className="inputLabel" htmlFor="lieferanschrift">
            Lieferanschrift:
          </label>
          <textarea
            name="lieferanschrift"
            id="lieferanschrift"
            style={{ height: '100px' }}
            readOnly={true}
          >
            {lieferAddesse}
          </textarea>
          <br className="clearBoth" />
          <LabelInput
            id="bestellreferenz"
            name="bestellreferenz"
            labelText="Bestellreferenz"
            type="text"
            inputDynparam={{
              defaultValue: this.props.data.orderInfo.bestellreferenz,
              readOnly: true,
            }}
          />
          <LabelInput
            id="besteldatum"
            name="besteldatum"
            labelText="Bestelldatum"
            type="text"
            inputDynparam={{
              defaultValue: besteldatum,
              readOnly: true,
            }}
          />
          <LabelInput
            id="zahlart"
            name="zahlart"
            labelText="Zahlart"
            type="text"
            inputDynparam={{
              defaultValue: this.props.data.orderInfo.Zahlart,
              readOnly: true,
            }}
          />
        </form>
        <div style={{ marginLeft: '20px' }}>
          <h2>Rechnungen</h2>
          <table>
            <thead>
              <tr>
                <th>Datum</th>
                <th>Nummer</th>
                <th>Betrag</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.orderInfoRechnug.map((itemR, indexR) => {
                let dateObject = new Date(itemR.rechnungsdatum);
                let formattedDate = '';
                if (!isNaN(dateObject.getTime()))
                  formattedDate = dateObject.toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  });
                let classNameRow = 'row' + (indexR % 2 == 1 ? ' mod2' : '');
                return (
                  <tr className={classNameRow}>
                    <td>{formattedDate}</td>
                    <td>
                      <a
                        href={
                          downloadPrefix + '&filename=' + itemR.rechnungsdatei
                        }
                        target={'_blank'}
                      >
                        {itemR.mol_rechnung_id}
                      </a>
                    </td>
                    <td>
                      {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(itemR.forderung)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <br />
        <table>
          <thead>
            <tr>
              <th>Menge</th>
              <th>Bezeichnung</th>
              <th>EK-Preis</th>
              <th>VK-Preis</th>
              <th>Mwst</th>
            </tr>
          </thead>
          <tbody>
            {this.props.data.orderInfoDetails.map((item, index) => {
              let key = 'pos_' + item.mol_auftrag_position_id;
              let classNameRow =
                'OrderInfo_mol ' + (index % 2 == 1 ? ' mod2' : ''); //OrderInfo_mol
              //let itemLink = '/konto/orders/' + item.orders_id;

              let nameText = item.pos_bezeichnung;

              if (item.Autor != undefined && item.Titel != undefined) {
                nameText = item.Autor + ' - ' + item.Titel;
                if (item.Verlag != undefined) nameText += ' | ' + item.Verlag;
              }

              let nameHtml: any = null;

              if (item.pim_artikel_id != 1786384) {
                nameHtml = (
                  <a
                    href={'buch/' + item.pim_artikel_id + '-/'}
                    target="_blank"
                  >
                    {nameText}
                  </a>
                );
              } else {
                nameHtml = nameText;
              }

              let bestellReferenz: any[] = [];

              for (
                let i = 0;
                i < this.props.data.orderBBPositions.length;
                i++
              ) {
                if (
                  item.pim_artikel_id ==
                  this.props.data.orderBBPositions[i].products_id
                ) {
                  let details = this.props.data.orderBBPositions[i].details;
                  let bbitems = JSON.parse(details);
                  for (let j = 0; bbitems != null && j < bbitems.length; j++) {
                    bestellReferenz.push(bbitems[j]);
                  }
                }
              }

              let bestellInfo: any[] = [];

              for (
                let i = 0;
                i < this.props.data.orderInfoDetailsBestell.length;
                i++
              ) {
                if (
                  item.mol_auftrag_position_id ==
                  this.props.data.orderInfoDetailsBestell[i]
                    .mol_auftrag_position_id
                ) {
                  bestellInfo.push(this.props.data.orderInfoDetailsBestell[i]);
                }
              }
              //debugger;
              let status = item.Status;
              let storno = item.Storno;
              let statusCode = 0;
              if (item.Status != null) {
                statusCode = +item.Status.substr(0, 3);
              }

              let dynTrBestellReferenz: any = null;
              let dynTrBestellReferenz_temp: any = null;

              dynTrBestellReferenz_temp = bestellReferenz.map(
                (item2, index2) => {
                  let key_id = key + 'beR' + index2;

                  return (
                    <div id={key_id} key={key_id}>
                      {item2.count} x {item2.text}
                    </div>
                  );
                },
              );
              if (bestellReferenz.length > 0) {
                dynTrBestellReferenz = (
                  <tr className="detailinfo">
                    <td></td>
                    <td style={{ border: 'solid 1px' }}>
                      {dynTrBestellReferenz_temp}
                    </td>
                  </tr>
                );
              }

              let dynTrBestellData = bestellInfo.map((item2, index2) => {
                let key_id = key + '_be_' + index2;
                let dateObject = new Date(item2.bestell_datum);
                let formattedDate = '';
                if (!isNaN(dateObject.getTime()))
                  formattedDate = dateObject.toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  });

                return (
                  <tr id={key_id} key={key_id} className="details">
                    <td></td>
                    <td className="dynTrBestellData">
                      Für Sie bei unserem Lieferanten bestellt: {formattedDate}
                      {item2.bestell_menge > 1
                        ? ': ' + item2.bestell_menge + ' x'
                        : null}
                    </td>
                  </tr>
                );
              });

              let incommingTrackingInfo: any[] = [];

              for (
                let i = 0;
                i < this.props.data.orderInfoDetailsIncommingTracking.length;
                i++
              ) {
                if (
                  item.mol_auftrag_position_id ==
                  this.props.data.orderInfoDetailsIncommingTracking[i]
                    .mol_auftrag_position_id
                ) {
                  incommingTrackingInfo.push(
                    this.props.data.orderInfoDetailsIncommingTracking[i],
                  );
                }
              }

              let dynTrIncommingTrackingData = incommingTrackingInfo.map(
                (item2, index2) => {
                  let key_id = key + '_it_' + index2;
                  let dateObject = new Date(item2.lieferscheindatum);
                  let formattedDate = '';
                  if (!isNaN(dateObject.getTime()))
                    formattedDate = dateObject.toLocaleDateString('de-DE', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    });

                  return (
                    <tr id={key_id} key={key_id} className="details">
                      <td className="dynTrIncommingTrackingData"></td>
                      <td>
                        Lieferung zum Buchbutler {formattedDate}
                        {item2.bestell_menge > 1
                          ? ': ' + item2.bestell_menge + ' x'
                          : null}
                      </td>
                    </tr>
                  );
                },
              );

              let trackingInfo: any[] = [];

              for (
                let i = 0;
                i < this.props.data.orderInfoDetailsTracking.length;
                i++
              ) {
                if (
                  item.mol_auftrag_position_id ==
                  this.props.data.orderInfoDetailsTracking[i]
                    .mol_auftrag_position_id
                ) {
                  trackingInfo.push(
                    this.props.data.orderInfoDetailsTracking[i],
                  );
                }
              }

              let dynTrTrackingData = trackingInfo.map((item2, index2) => {
                let key_id = key + '_tr_' + index2;
                let dateObject = new Date(item2.liefer_datum);
                let formattedDate = '';
                if (!isNaN(dateObject.getTime()))
                  formattedDate = dateObject.toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  });

                let trackinglink = <>{item2.trackingnummer}</>;

                if (item2.logistiker == 'DHL') {
                  trackinglink = (
                    <a
                      href={
                        'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=' +
                        item2.trackingnummer
                      }
                      target={'_blank'}
                    >
                      {item2.trackingnummer}
                    </a>
                  );
                } else if (
                  item2.logistiker == 'Deutsche Post' &&
                  item2.mol_lieferant_id == 5
                ) {
                  <a
                    href={
                      'https://www.deutschepost.de/de/s/sendungsverfolgung/verfolgen.html?piececode=' +
                      item2.trackingnummer +
                      '&lang=de&cid=brief'
                    }
                    target={'_blank'}
                  >
                    {item2.trackingnummer}
                  </a>;
                }

                return (
                  <tr id={key_id} key={key_id} className="details">
                    <td></td>
                    <td>
                      Lieferung {formattedDate}: {item2.liefer_menge}x{' '}
                      {item2.logistiker} {item2.logistik_produkt} {trackinglink}
                    </td>
                  </tr>
                );
              });

              return (
                <>
                  <tr id={key} key={key} className={classNameRow}>
                    <td
                      className={
                        'left top' + item.pim_artikel_id == '1786384'
                          ? ' bottom'
                          : ''
                      }
                      rowSpan={item.pim_artikel_id != '1786384' ? 2 : 1}
                    >
                      {item.menge}
                    </td>
                    <td>{nameHtml}</td>
                    <td align="right">
                      {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(item.vk_brutto)}
                    </td>
                    {item.pim_artikel_id != '1786384' ? (
                      <>
                        <td align="right">
                          {new Intl.NumberFormat('de-DE', {
                            style: 'currency',
                            currency: 'EUR',
                          }).format(item.pv)}
                        </td>
                        <td align="right">
                          {(+item.tax).toLocaleString('de-DE', {
                            style: 'percent',
                          })}
                        </td>
                      </>
                    ) : (
                      <>
                        <td></td>
                        <td></td>
                      </>
                    )}
                  </tr>
                  {item.pim_artikel_id != '1786384' ? (
                    <tr
                      id={key + '_rabatt'}
                      key={key + '_rabatt'}
                      className={classNameRow}
                    >
                      <td>
                        <a
                          href={'buch/' + item.pim_artikel_id + '-/'}
                          target="_blank"
                        >
                          {item.ean}
                        </a>
                      </td>
                      <td style={{ textAlign: 'end' }}>Rabatt</td>
                      <td style={{ textAlign: 'center' }}>
                        {item.rabatt != null
                          ? (+item.rabatt).toLocaleString('de-DE', {
                              style: 'percent',
                            })
                          : null}
                      </td>
                      <td />
                    </tr>
                  ) : null}
                  {item.pim_artikel_id != 1786384 ? (
                    <tr className="image_row" data-Staus={statusCode}>
                      <td></td>
                      <td>
                        {statusCode >= 100 ? (
                          <img
                            src={img01_activ}
                            title={
                              'Wir haben Ihren Auftrag #' +
                              this.props.data.orderInfo.mol_auftrag_id +
                              ' erhalten'
                            }
                            alt="Auftrag"
                          />
                        ) : (
                          <img
                            src={img01_inactiv}
                            title="Wir erwarten Ihren Auftrag"
                            alt="Auftrag"
                          />
                        )}
                        {statusCode >= 200 ? (
                          <img
                            src={img02_activ}
                            title="Wir haben Ihr Produkt bei unserem Lieferanten für Sie bestellt"
                            alt="Bestellung durch uns beim Lieferanten"
                          />
                        ) : (
                          <img
                            src={img02_inactiv}
                            title="Wir werden Ihr Produkt umgehend bei unserem Lieferanten für Sie bestellen"
                            alt="Bestellung durch uns beim Lieferanten"
                          />
                        )}
                        {statusCode >= 300 ? (
                          <img
                            src={img03_activ}
                            title="Unser Lieferant hat unsere Bestellung bei Ihm erhalten"
                            alt="Lieferant hat den Versand an uns angekündigt / Artikel ist auf dem Weg zu uns"
                          />
                        ) : (
                          <img
                            src={img03_inactiv}
                            title="Wir haben von unserem Lieferanten noch keine Rückmeldung zu unserer Bestellung erhalten"
                            alt="Lieferant hat unsere Bestellung bestätigt/Bearbeitung bei unserem Lieferanten"
                          />
                        )}
                        {statusCode >= 400 ? (
                          <img
                            src={img04_activ}
                            title="Unser Lieferant hat den für Sie bestellten Artikel intern reserviert oder uns bereits einen elektronischen Lieferschein übermittelt"
                            alt="Lieferant hat den Versand an uns angekündigt / Artikel ist auf dem Weg zu uns"
                          />
                        ) : (
                          <img
                            src={img04_inactiv}
                            title="Wir haben von unserem Lieferanten noch keine Rückmeldung zu unserer Bestellung erhalten"
                            alt="Lieferant hat den Versand an uns angekündigt / Artikel ist auf dem Weg zu uns"
                          />
                        )}
                        {statusCode >= 500 ? (
                          <img
                            src={img05_activ}
                            title="Wir haben Trackinginformationen zu dem angekündigten Paket auf dem Weg zu uns, in dem Ihr Artikel enthalten ist"
                            alt="Tracking von unserem Lieferanten zu uns"
                          />
                        ) : (
                          <img
                            src={img05_inactiv}
                            alt="Tracking von unserem Lieferanten zu uns"
                          />
                        )}
                        {statusCode >= 600 ? (
                          <img
                            src={img06_activ}
                            title="Der Artikel ist bei uns im Lager angekommen und sowohl der Wareneingang als auch der Warenausgang ist bereits erledigt. Dem Versand durch uns an Sie steht nichts mehr im Wege."
                            alt="Der Artikel ist bei uns im Lager angekommen und versandbereit durch uns"
                          />
                        ) : (
                          <img
                            src={img06_inactiv}
                            title="Wir erwarten Ihren bestellten Artikel in kürze bei uns im Lager."
                            alt="Der Artikel ist bei uns im Lager angekommen und versandbereit durch uns"
                          />
                        )}
                        {statusCode >= 700 ? (
                          <img
                            src={img07_activ}
                            title="Das Paketlabel wurde gedruckt und Ihr Paket wird noch heute an DHL übergeben."
                            alt="Der Artikel wurde von uns an Sie versendet"
                          />
                        ) : (
                          <img
                            src={img07_inactiv}
                            title="Ihr bestellter Titel ist noch nicht bei uns angekommen."
                            alt="Der Artikel wurde von uns an Sie versendet"
                          />
                        )}
                        {statusCode >= 800 ? (
                          <img
                            src={img08_activ}
                            title="Laut den Trackingdaten wurde das Paket bereits an Sie zugestellt"
                            alt="Das Paket wurde an den Kunden zugestellt"
                          />
                        ) : (
                          <img
                            src={img08_inactiv}
                            title=""
                            alt="Das Paket wurde an den Kunden zugestellt"
                          />
                        )}
                        {statusCode >= 900 ? (
                          <img
                            src={img09_activ}
                            title="Wir haben eine Retoure zu dieser Bestellposition erfasst. Sie erhalten automatisch eine Gutschrift von uns"
                            alt="Retoure"
                          />
                        ) : null}
                        {storno == 'JA' ? (
                          <img
                            src={img_storno}
                            title="Position ist storniert"
                            alt="Storno"
                          />
                        ) : null}
                      </td>
                    </tr>
                  ) : null}
                  {dynTrBestellReferenz}
                  {dynTrBestellData}
                  {dynTrIncommingTrackingData}
                  {dynTrTrackingData}
                  <tr className="dummy_space">
                    <td colSpan={5}> </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  componentDidMount(): void {
    let winAny: any = window;
    let location = winAny.historyHelper.memory.location;
    if (this.props.data.jumpPosition != null) {
      let item: any = document.getElementById(
        'pos_' + this.props.data.jumpPosition,
      );
      item.classList.add('activ');
      var rect = item.getBoundingClientRect();
      winAny.scrollTo(0, rect.top);
    } else {
      if (location.hash != '') {
        if (location.hash.startsWith('#')) {
          let item: any = document.getElementById(location.hash.substring(1));
          item.classList.add('activ');
          var rect = item.getBoundingClientRect();
          winAny.scrollTo(0, rect.top);
        }
      }
    }
  }
}
